import Styled from 'styled-components';

// Off-screen text for accessible names. The design system's Button derives its own aria-label from the
// icon name and applies it after the caller's props, so an icon-only button takes its accessible name from
// one of these through aria-labelledby instead; a NumberField, which forwards no aria props, is labelled by
// wrapping it in a <label> that holds one. The nearest positioned ancestor should be `position: relative`.
export const HiddenLabel = Styled.span`
	position: absolute;
	width: 1px;
	height: 1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
`;
